// extracted by mini-css-extract-plugin
export default {"translation-preference-form-toggle-input":"translation-preference-form-toggle-input----bJ6","translationPreferenceFormToggleInput":"translation-preference-form-toggle-input----bJ6"};